const proxy = "https://brownbytes.org:3000";

export default proxy;
